<template>
  <div class="container">
    <h1>
      <font-awesome-icon icon="home" /> Home - <a href="#">Course Grading</a>
    </h1>
    <div class="text-center" v-if="isLoading">
      <b-spinner variant="primary" label="Text Centered"></b-spinner>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="panal mt-20">
          <div class="panal-header">Student Data</div>
   <div class="panal-body">

  <div class="app-All">
              <div class="app-stu col-md-6 col-sm-12 ">
                <div class="title">Student Name : <span> {{personalData[0].FirstNameEN+' '+personalData[0].SecondNameEN+' '+personalData[0].ThirdNameEN}}</span></div>
              </div>
              <div class="app-stu col-md-6 col-sm-12">
                <div class="title">Year/Term: <span>{{Transcript[0].Name}}</span></div>
              </div>
              <div class="app-stu col-md-6 col-sm-12">
                <div class="title">CGPA : <span>{{TranscriptDetails[0].CGPA}}</span></div>
              </div>
              <div class="app-stu col-md-6 col-sm-12">
                <div class="title">Faculty Name : <span>{{personalData[0].FacultyName_EN}}</span></div>
              </div>
           
            </div>
            <div class="app-stu-photo"><img src="../../assets/SU_Logo.png" /></div>


<div class="clearfix"></div>

</div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="panal mt-20">
          <div class="panal-header">Search List</div>
          <div class="panal-body">
            <div
              v-if="message"
              class="alert"
              :class="successful ? 'alert-success' : 'alert-danger'"
            >
              {{ message }}
            </div>
            <div class="table-responsive" v-else>
              <table class="table mt-3 table-bordered">
                <thead class="thead-light">
                  <tr>
                    <th scope="col">Course Name</th>
                    <th scope="col">Course code</th>
                    <th scope="col">Year</th>
                    <th scope="col">Semester</th>
                    <th scope="col">Select</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="courses.length == 0">
                    <td colspan="7">No Data</td>
                  </tr>

                  <tr
                    v-else
                    v-for="item in courses"
                    v-bind:Key="item.StudentID"
                  >
                    <td>{{ item.CourseNameEN }}</td>
                    <td>{{ item.CourseCode }}</td>
                    <td></td>
                    <td>Fall</td>
                    <td>
                      <b-button
                        variant="success"
                        @click="getQuiz(item)"
                        v-bind:Key="item.CourseNameEN"
                        >Select</b-button
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="Grading.length">
      <div class="col-md-6 mx-auto">
        <div class="panal mt-20">
          <div class="panal-header">Quaz</div>
          <div class="panal-body">
            <div class="table-responsive">
              <table class="table mt-3 table-bordered">
                <thead class="thead-light">
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">Quaz Name</th>
                    <th scope="col">Grade</th>
                    
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="Grading.length == 0">
                    <td colspan="7">No Data</td>
                  </tr>
                  <tr
                    v-else
                    v-for="item in Grading"
                    v-bind:Key="item.CourseNameEN"
                  >
                    <td></td>
                    <td>{{ item.TemplateDetails }}</td>
                    <td>{{ item.StudentDegree }}</td>
                    <td>10</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import studentData from "../../services/student/studentDataServices";
export default {
  name: "CourseGrading",
  data() {
    return {
      isLoading: true,
      selected: null,
      show: true,
      isHidden: true,
      Grading: [],
      personalData: "",
      message: "",
      courses: "",
      quazs: [],
      CourseNameEN: "",
      currentItem:""
    };
  },
  methods:{
    getQuiz(item){
      
          this.currentItem  = item;
          //this.currenUser.StudentID,item.CourseID,item.RoleReviewID  // 25096, 500, 2
          studentData.GetStudentActivityGrading(this.currenUser.StudentID,item.CourseID,item.RoleReviewID).then(
             (Response) => {
          this.isLoading = false;
          this.Grading = Response.data;
          // eslint-disable-next-line no-console
          // console.log(this.Grading);
        },
        (error) => {
          // eslint-disable-next-line no-console
          // console.log(error.response.status);

          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.Message) ||
            error.message ||
            error.toString();

          if (error.response.status == 404) this.message = "";
        }
      
          )
    }
  },
  computed: {
    currenUser() {
      return this.$store.state.auth.user;
    },
  },

  mounted() {







    
    studentData.GetStudentData(this.currenUser.StudentID).then(
      (Response) => {
        this.isLoading = false;
        this.personalData = Response.data;
        // eslint-disable-next-line no-console
        // console.log(Response.data);
      },
      (error) => {
        // eslint-disable-next-line no-console
        // console.log(error.response.status);

        this.message =
          (error.response &&
            error.response.data &&
            error.response.data.Message) ||
          error.message ||
          error.toString();

        if (error.response.status == 404) this.message = "";
      }
    ),
      //this.currenUser.StudentID
      // studentData.GetStudentActivityGrading(25096, 366, 3).then(
      //   (Response) => {
      //     this.isLoading = false;
      //     this.Grading = Response.data;
      //     // eslint-disable-next-line no-console
      //     console.log(this.Grading);
      //   },
      //   (error) => {
      //     // eslint-disable-next-line no-console
      //     console.log(error.response.status);

      //     this.message =
      //       (error.response &&
      //         error.response.data &&
      //         error.response.data.Message) ||
      //       error.message ||
      //       error.toString();

      //     if (error.response.status == 404) this.message = "";
      //   }
      // ),
      //this.currenUser.StudentID // 566
      studentData.getStudentScheduale(this.currenUser.StudentID).then(
        (Response) => {
          this.isLoading = false;
          this.courses = Response.data;
          // eslint-disable-next-line no-console
          // console.log(this.Grading);
        },
        (error) => {
          // eslint-disable-next-line no-console
          // console.log(error.response.status);

          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.Message) ||
            error.message ||
            error.toString();

          if (error.response.status == 404) this.message = "";
        }
      );

      
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
h1 {
  color: #285475;
  font-size: 25px;
  border-bottom: 1px #646464 dashed;
  padding: 10px 0px;
}
h1 a {
  color: #50bd77;
}

.panal {
  background: #fff;
  border-radius: 10px;
  color: #fff;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body {
  padding: 20px;
  color: #333;
}

.app-stu-photo {
  float: right;
  width: 200px;
  border-radius: 10px;
  border: 1px solid #111;
  margin-top: 20px;
}

.app-stu-photo img {
  width: 100%;
  border-radius: 10px;
}

.app-All {
  width: 75%;
  float: left;
}

.app-stu {
  border-bottom: 1px #333 dotted;
  padding: 10px 0px;

  float: left;
}

.app-stu .title {
  font-weight: bold;
}

.app-stu .title span {
  font-weight: 100;
}

.table .thead-dark th {
  color: #fff;
  background-color: #dee2e6 !important;
  border-color: #989899 !important;
  font-size: 13px !important;
}
.table .thead-light th {
  color: #495057;
  background-color: #e9ecef;
  border-color: #dee2e6;
  font-size: 13px !important;
}

.bg-filter {
  background: #cacaca;
  padding: 10px;
  width: 100%;
}
.show {
  display: none;
}
</style>
